import { Component } from '@angular/core';

@Component({
  selector: 'app-content-card7',
  imports: [],
  templateUrl: './content-card7.component.html',
  styleUrl: './content-card7.component.scss'
})
export class ContentCard7Component {

}
